module.exports = __webpack_public_path__ + "catalog/items/bathroom/Straight-Corner-Shower/Straight-Corner-Shower.svg";